/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum RouteName {
    Main = 'booking',
    TimeslotsNew = 'timeslots',
    Options = 'options',
    Packages = 'packages',
    BookingReservations = 'login/reservations',
    SellerLogin = 'seller/login',
    BookingLogin = 'login',
    Gift = 'package/5',
    Subscription = 'package/6',
    ThreeTwo = 'package/21',
    PackageDetail = 'package',
    Upsells = 'upsell',
    UpsellsNew = 'upsells',
    Timeslots = 'book',
    Customer = 'customer',
    Inquiry = 'inquiry',
    Checkin = 'status-booking',
    Paid = 'paid',
    GiftCheckout = 'checkout',
}
